import { dateFnsLocalizer } from 'react-big-calendar'
import { format, parse, startOfWeek, getDay } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales: { 'pt-BR': ptBR },
})

export function toDateTime(dateStr, timeStr) {
    return new Date(`${dateStr}T${timeStr}:00`)
}

export function pad2(n) {
    return String(n).padStart(2, '0')
}

export function dateToDateStr(date) {
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

export function dateToTimeStr(date) {
    return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`
}
